import { render } from "./Waves.vue?vue&type=template&id=03c6cfff&scoped=true&bindings={}"
import script from "./Waves.vue?vue&type=script&lang=js"
export * from "./Waves.vue?vue&type=script&lang=js"

import "./Waves.vue?vue&type=style&index=0&lang=scss"
import "./Waves.vue?vue&type=style&index=1&id=03c6cfff&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-03c6cfff"

export default script